import A from 'utils/metrics/analytic'

// Открытие видеолекции

enum originLectures {
  LIBRARY = 'library',
  RECOMENDATION = 'recomendation',
  FEED = 'feed',
  VIDEOPROJECT = 'videoprojec',
  LANDING = 'landing',
  PLAYLIST = 'playlist',
  NOORIGIN = 'noorigin',
}

const A_lec_openLectures = (origin: originLectures, id: number) => {
  if (origin === originLectures.NOORIGIN) {
    A.setEvent('article_video_open', { id: String(id) })
  } else {
    A.setEvent('article_video_open', { origin, id: String(id) })
  }
}

export { A_lec_openLectures, originLectures }
